<header class="cx-header-mobile">
  <div class="container">
    <div class="d-flex gap-3 align-items-center justify-content-between">
      <icon-hamburguer></icon-hamburguer>

      <div class="cx-header-mobile__top">
        <span class="cx-header-mobile__top--user text-truncate">
          @if (user$ | async; as user) {
            {{ 'header.hello' | translate: { name: user.firstName } }}
          }
        </span>

        <span class="cx-header-mobile__top--separator"></span>

        <span class="cx-header-mobile__top--b2b-unit">
          @if (b2bUnit$ | async; as b2bUnit) {
            <span class="text-truncate"
              ><b>{{ 'header.b2bUnitDetails' | translate }}:</b> {{ b2bUnit.name }}</span
            >
          }
          <button type="button" (click)="openB2bUnitModal()">
            <span class="material-symbols-outlined fs-5">info</span>
          </button>
        </span>

        <span class="cx-header-mobile__top--separator"></span>

        <div class="cx-header-mobile__top--mini-cart">
          <mini-cart></mini-cart>
        </div>
      </div>
    </div>
  </div>

  <div class="cx-header-mobile__searchbar">
    <div class="container d-flex align-items-center justify-content-between h-100">
      <a [routerLink]="''" class="cx-header-mobile__searchbar--logo">
        <cx-abstract [component]="components | cmsComponent: CX_COMPONENT.LOGO" />
      </a>
      <search-box></search-box>
    </div>
  </div>
</header>

<toggleable-menu [components]="components"></toggleable-menu>
